import { getMicroserviceBaseContext } from '../../constants/api-routing';

const authContext = getMicroserviceBaseContext('auth');

export const AUTH_SERVICE = {
    createProfile: `${authContext}create_user_profile`,
    updateUserProfile: `${authContext}update_user_profile`,
    getUserProfile: `${authContext}user_profile_list_v2/`,
    userProfileList: `${authContext}user_profile_list`,
    getTraineeListSummary: `${authContext}user_profile_list_summary/`,
    getTraineeSummaryById: `${authContext}get_user_profile_list_summary_by_id`,
    deleteUserProfile: `${authContext}delete_user_profile`,
    defaultBUMarketCreateUpdate: `${authContext}user_default_bu_market/create_update`,
    defaultBUMarketGetList: `${authContext}user_default_bu_market/get_list`,
    userRoleList: `${authContext}user_role_list/`,
    userRoleLabel: `${authContext}user_role_label_list/`,
    userRoleByRoleId: `${authContext}user_role_by_role_id`,
    showPadUserVerification: `${authContext}verify-showpad-email`
}
